import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme }) => ({
  minHeight: 40,
  paddingInline: theme.spacing(2.5),
}));

const BaseButton = (props: ButtonProps) => <StyledButton disableElevation {...props} />;

export type { ButtonProps };
export default BaseButton;
